<template>
	<div class="list_con">
		<div class="flex list_every_data list_every" v-for="(item, index) in list" :key="index" @click="jump(item)">
			<div class="list_left">
				<div class=" c1 every_txt fz-16 fw-500 h40 w176 text-hide3">{{item.title}}</div>
				<div class="c3 fz-10">{{item.data}}</div>
			</div>
			<div class="list_right">
				<!-- <img v-lazy="item.picture" alt=""> -->
				<van-image :src="item.picture" :lazy-load="true">
					<template v-slot:error>
						<img class="wh_36 b-radius-6" src="../assets/img/icon/error.png" alt="">
					</template>
				</van-image>
				<!-- <div>125:37:00</div> -->
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			}
		},
		data() {
			return {

			}
		},
		mounted() {},
		methods: {
      jump(data){
				if(data.network_link){
          window.location.href = data.network_link
				}
        
			}
		}
	}
</script>
<style lang="less" scoped>
	.list_every_data {
		justify-content: space-between;
		margin: 0 10px 0 11px;
		padding: 12px 0;
		border-bottom: 1px solid #EEEEEE;

		&:last-child {
			border-bottom: none;
		}

		.list_right {
			width: 120px;
			height: 72px;

			/deep/.van-image{
				width: 100%;
				height: 100%;
			}

			
		}

		.list_left {
			width: 176px;
			padding-top: 2px;

			.every_txt {
				margin-bottom: 16px;
			}
		}

	}
</style>
